module.exports = __webpack_public_path__ + "img/[撇嘴].d570fce2.svg";